import {PREFERENCES_FORM_MAX_DEFAULT, PREFERENCES_FORM_STEP} from "../constants/preferences_form";

export const usePreferencesMaxValue = (price?: number | null) => {
    return price && price > PREFERENCES_FORM_MAX_DEFAULT ? Math.ceil(price / PREFERENCES_FORM_STEP) * PREFERENCES_FORM_STEP : PREFERENCES_FORM_MAX_DEFAULT;
};
import {PREFERENCES_FORM_MAX_DEFAULT, PREFERENCES_FORM_STEP} from "../constants/preferences_form";

export const usePreferencesMaxValue = (price?: number | null) => {
    return price && price > PREFERENCES_FORM_MAX_DEFAULT ? Math.ceil(price / PREFERENCES_FORM_STEP) * PREFERENCES_FORM_STEP : PREFERENCES_FORM_MAX_DEFAULT;
};
